module.exports = __webpack_public_path__ + "assets/images/3ec2511950f15976ba623079ec1349ec.jpg";